import { ColumnTypeEnum } from '../base-column/column-type-enum';
import { Column, ColumnConfig, IColumn } from '../base-column/column.model';

import { initFromConfig, initFromProps } from '../common-models/init-functions';
import { SeverityEnum } from '../label-column/severity-enum';

export interface HyperlinkColumnConfig<T> extends ColumnConfig<T> {
  urlPropertyName?: string;
}

export class HyperlinkColumn<T> extends Column<T> implements IColumn<T> {
  fileUrlProp?: string;
  urlPropertyName?: string;

  constructor(config: HyperlinkColumnConfig<T>);
  constructor(
    name?: string,
    propertyName?: string,
    fileUrlProp?: string,
    tooltip?: string | ((item?: any) => string),
    action?: (item?: T, event?: any) => any
  );
  constructor(
    configOrName?: HyperlinkColumnConfig<T> | string,
    propertyName?: string,
    fileUrlProp?: string,
    tooltip?: string | ((item?: any) => string),
    action?: (item?: T, event?: any) => any
  ) {
    super();
    if (typeof configOrName === 'object') {
      const config = configOrName as HyperlinkColumnConfig<T>;
      initFromConfig(this, config);
      this.fileUrlProp = config.urlPropertyName;
      this.urlPropertyName = config.urlPropertyName;
    } else {
      initFromProps(
        this,
        configOrName,
        propertyName,
        undefined,
        tooltip,
        action
      );
      this.fileUrlProp = fileUrlProp;
    }
  }

  GetAction(row: T, event?: any) {
    if (this.Action) {
      return this.Action(row, event);
    } else {
      throw new Error('Action is not defined in label column.');
    }
  }

  GetTooltip(): string | ((item?: any) => string) {
    return this.Tooltip ?? null;
  }

  GetSort(): boolean {
    return false;
  }
  GetPropertyName(): string {
    return this.PropertyName ?? null;
  }
  GetName(): string {
    return this.Name ?? '';
  }
  //Θα επιστρέφει το αντίστοιχο entry από το Enum για DateColumn
  GetColumnType(): string {
    return ColumnTypeEnum.HyperlinkColumn;
  }

  //Θα πρέπει να επιστρέφει το value που θα εμφανιστεί στο grid βασισμένο στο Propertyname μετά από τους μετασχηματισμούς.
  //Για την υποστήριξη των nested object θα πρέπει να υπάρχει split και recursive αναζήτηση των properties.
  GetValue(): string | ((item?: any) => string) {
    return this.Action ?? '';
  }

  GetSeverity(obj?: T): SeverityEnum {
    const status = obj != undefined ? obj : '';
    return status === true ? SeverityEnum.Success : SeverityEnum.Danger;
  }

  getFileUrlProp(): string {
    return this.fileUrlProp ?? '';
  }
}
